<script lang="ts">
  import Loader from "../../ui/icons/Loader.svelte"
  import { t } from "../lang/i18n"
  // import LoaderAidenLogo from "./icons/LoaderAidenLogo.svelte"

  export let isLoading: boolean = false
  let displayLoading: boolean = false
  let timeout: number | undefined = undefined

  $: {
    if (isLoading && !timeout) {
      timeout = window.setTimeout(function () {
        displayLoading = true
        timeout = undefined
      }, 250)
    } else if (!isLoading) {
      displayLoading = false
    }
  }
</script>

{#if displayLoading}
  <Loader aria-label={$t("loading")} />
{:else}
  <slot />
{/if}
